import { useCallback, useState } from "react";

export type SidebarSettings = {
  isCollapsed: boolean;
};

export const DEFAULT_SIDEBAR_SETTINGS: SidebarSettings = {
  isCollapsed: false,
};

export function getSidebarSettings(): SidebarSettings {
  const sidebarSettingsStr = localStorage.getItem("sidebar.settings");
  const sidebarSettings =
    sidebarSettingsStr === null
      ? DEFAULT_SIDEBAR_SETTINGS
      : JSON.parse(sidebarSettingsStr);
  return sidebarSettings;
}

export function setSidebarSettings(sidebarSettings: SidebarSettings) {
  const sidebarSettingsExisting = getSidebarSettings();
  localStorage.setItem(
    "sidebar.settings",
    JSON.stringify({ ...sidebarSettingsExisting, ...sidebarSettings }),
  );
}

export function useSidebarSettings() {
  const [sidebarSettings, setSidebarSettingsState] =
    useState(getSidebarSettings());

  const setSidebarSettingsCallback = useCallback(
    (sidebarSettings: SidebarSettings) => {
      setSidebarSettings(sidebarSettings);
      setSidebarSettingsState(sidebarSettings);
    },
    [],
  );

  return [sidebarSettings, setSidebarSettingsCallback] as const;
}
